module.exports = __webpack_public_path__ + "statics/img/user-multiple.557d7ec3.svg";